<template>
  <v-layout column>
    <v-flex>
     <span class="headline">
       Tiempo
     </span>
    </v-flex>
    <v-flex>
      <v-card>
        <v-card-text class="clickable" @click="$emit('showAgent')">
            <v-layout row>
              <v-flex md4>
                <transition name="fade-effect" mode="out-in">
                  <skeleton-box flat v-if="isSearching">
                    <skeleton-line class="custom-line"></skeleton-line>
                  </skeleton-box>
                  <div class="borders" v-else>
                    <v-flex xs12>
                      <span class="custom-caption">
                        Tiempo promedio de respuesta
                      </span>
                    </v-flex>
                    <v-flex xs12 pl-3 pa-0>
                      <span class="display-3">
                        {{ toHuman(data.unanswered) }}
                      </span>
                    </v-flex>
                    <v-flex pt-0 pb-0 class="text-xs-right" xs12>
                      <v-icon small v-if="percentage.unanswered !== 0" 
                        :class="[percentage.unanswered > 0 ? 'red--text' : 'green--text']">
                        fas fa-sort-{{percentage.unanswered >= 0 ? 'up' : 'down'}}
                      </v-icon>
                      <span :class="[percentage.unanswered > 0 ? 'red--text' : 'green--text']">
                        {{ percentage.unanswered }}%
                      </span>
                    </v-flex>
                  </div>
                </transition>
              </v-flex>
              <v-flex md4>
                <transition name="fade-effect" mode="out-in">
                  <skeleton-box flat v-if="isSearching">
                    <skeleton-line class="custom-line"></skeleton-line>
                  </skeleton-box>
                  <div class="borders" v-else>
                    <v-flex xs12>
                      <span class="custom-caption">
                        Tiempo promedio de espera
                      </span>
                    </v-flex>
                    <v-flex xs12 pl-3 pa-0>
                      <span class="display-3">
                        {{ toHuman(data.queued) }}
                      </span>
                    </v-flex>
                    <v-flex pt-0 pb-0 class="text-xs-right" xs12>
                      <v-icon small v-if="percentage.queued !== 0" 
                        :class="[percentage.queued > 0 ? 'red--text' : 'green--text']">
                        fas fa-sort-{{percentage.queued >= 0 ? 'up' : 'down'}}
                      </v-icon>
                      <span :class="[percentage.queued > 0 ? 'red--text' : 'green--text']">
                        {{ percentage.queued }}%
                      </span>
                    </v-flex>
                  </div>
                </transition>
              </v-flex>
              <v-flex md4>
                <transition name="fade-effect" mode="out-in">
                  <skeleton-box flat v-if="isSearching">
                    <skeleton-line class="custom-line"></skeleton-line>
                  </skeleton-box>
                  <div class="borders" v-else>
                    <v-flex xs12>
                      <span class="custom-caption">
                        Tiempo promedio de resolución
                      </span>
                    </v-flex>
                    <v-flex xs12 pl-3 pa-0>
                      <span class="display-3">
                        {{ toHuman(data.solved) }}
                      </span>
                    </v-flex>
                    <v-flex pt-0 pb-0 class="text-xs-right" xs12>
                      <v-icon small v-if="percentage.solved !== 0" 
                        :class="[percentage.solved > 0 ? 'red--text' : 'green--text']">
                        fas fa-sort-{{percentage.solved >= 0 ? 'up' : 'down'}}
                      </v-icon>
                      <span :class="[percentage.solved > 0 ? 'red--text' : 'green--text']">
                        {{ percentage.solved }}%
                      </span>
                    </v-flex>
                  </div>
                </transition>
              </v-flex>
            </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import moment from 'moment';
import SkeletonLine from '@/components/global/skeletons/Line';
import SkeletonBox from '@/components/global/skeletons/SkeletonBox';

export default {
  components: {
    SkeletonBox,
    SkeletonLine,
  },
  data() {
    return {
      data: {
        queued: 0,
        solved: 0,
        unsolved: 0,
        unanswered: 0,
        queuedPrev: 0,
        solvedPrev: 0,
        unsolvedPrev: 0,
        unansweredPrev: 0,
      },
      isSearching: true,
    };
  },
  created() {
    moment.locale('es', {
      relativeTime: {
        future: 'en %d s',
        past: 'hace %d s',
        s: '%d s',
        m: '%d m',
        mm: '%d m',
        h: '%d h',
        hh: '%d h',
        d: '%d d',
        dd: '%d d',
        M: '%d M',
        MM: '%d M',
        y: '%d a',
        yy: '%d a',
      },
    });
  },
  mounted() {
    this.getData();
  },
  computed: {
    percentage() {
      return {
        queued: parseInt(this.calculatePercentage(this.data.queued, this.data.queuedPrev), 10),
        solved: parseInt(this.calculatePercentage(this.data.solved, this.data.solvedPrev), 10),
        // eslint-disable-next-line
        unsolved: parseInt(this.calculatePercentage(this.data.unsolved, this.data.unsolvedPrev), 10),
        // eslint-disable-next-line
        unanswered: parseInt(this.calculatePercentage(this.data.unanswered, this.data.unansweredPrev), 10),
      };
    },
  },
  methods: {
    toHuman(time) {
      return moment.duration(time, 'seconds').humanize();
    },
    calculatePercentage(val, old) {
      return ((val - old) / (old > 0 ? old : 1)) * 100;
    },
    getData() {
      this.isSearching = true;
      this.axios.get('chat/center/waiting/times').then(({ data }) => {
        this.data.queued = Number(data[0].queued);
        this.data.solved = Number(data[0].solved);
        this.data.unsolved = Number(data[0].unsolved);
        this.data.unanswered = Number(data[0].unanswered);
        if (data.length > 1) {
          this.data.queuedPrev = Number(data[1].queued);
          this.data.solvedPrev = Number(data[1].solved);
          this.data.unsolvedPrev = Number(data[1].unsolved);
          this.data.unansweredPrev = Number(data[1].unanswered);
        } else {
          this.data.queuedPrev = this.data.queued;
          this.data.solvedPrev = this.data.solved;
          this.data.unsolvedPrev = this.data.unsolved;
          this.data.unansweredPrev = this.data.unanswered;
        }
      }).catch(() => {}).finally(() => {
        this.isSearching = false;
      });
    },
  },
};
</script>
<style scoped>
.scrollBar {
  height: 30vh;
  width: 95%;
}
.borders {
  height: 25.5vh;
  border: 1px solid #ccc5c5;
}
.custom-caption {
  font-size: 10px;
}
.custom-line {
  height: 25.6vh;
  border-radius: 0 !important;
}
</style>





// WEBPACK FOOTER //
// src/components/chat_center_v2/dashboard/WaitTime.vue